module.exports = __webpack_public_path__ + "static/img/lelegu.9c3cfd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lelegu.jpg
// module id = E1h9
// module chunks = 1